import * as React from "react";

// Context to handle the publish button
export interface IPublishContext {
  publishState: any;
  setPublishState?: React.Dispatch<any>;
}
const initialPublishContextState: IPublishContext = {
  publishState: false,
  setPublishState: () => {}
};

const PublishContext = React.createContext<IPublishContext>(initialPublishContextState);
export const usePublishContext = () => React.useContext(PublishContext);

interface PublishProviderProps {}

const PublishProvider: React.SFC<PublishProviderProps> = props => {
  const [publishState, setPublishState] = React.useState(null);
  return (
    <PublishContext.Provider value={{publishState, setPublishState}}>
      {props.children}
    </PublishContext.Provider>
  );
};

export default PublishProvider;